import React from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import PropTypes from "prop-types";
import Toast from "../Toast";
import { clearNotification } from "../../redux/actions/notifications";
import { getVisibleNotifications, getAllNotifications } from "../../redux/selectors/notifications";
import withTranslation from "../../hocs/withTranslation";

const NotificationsContainer = ({
    notifications,
    clearNotificationConnect,
    remainingNotifications,
    t,
}) =>
    remainingNotifications > 0 && (
        <div className="pointer-events-none fixed bottom-4 right-4 z-50 flex w-80 max-w-[calc(100vw-2rem)] flex-col items-end gap-2">
            <span className="pointer-events-auto inline-flex items-center rounded-pill! bg-ink px-2 py-0.5 text-xs font-medium text-white">
                {`${t("messages.notification.remaining")}: ${remainingNotifications}`}
            </span>
            {notifications.map((notification) => (
                <div key={notification.id} className="pointer-events-auto w-full">
                    <Toast notification={notification} dismiss={clearNotificationConnect} />
                </div>
            ))}
        </div>
    );

export const mapStateToProps = (state) => ({
    notifications: getVisibleNotifications(state),
    remainingNotifications: getAllNotifications(state).length,
});

export const mapDispatchToProps = {
    clearNotificationConnect: clearNotification,
};

NotificationsContainer.propTypes = {
    notifications: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    clearNotificationConnect: PropTypes.func.isRequired,
    remainingNotifications: PropTypes.number.isRequired,
    t: PropTypes.func.isRequired,
};

export default compose(
    withTranslation,
    connect(mapStateToProps, mapDispatchToProps),
)(NotificationsContainer);
